// extracted by mini-css-extract-plugin
module.exports = {"mediaTypeContainer":"MediaType_mediaTypeContainer__2GAR0","barDiv":"MediaType_barDiv__PTMGX","doughnutDiv":"MediaType_doughnutDiv__2voh4"};